<div class="xwai-viz">
  @if (sliceResource.error()) {
  <div class="viz-placeholder viz-error">
    <span nz-icon nzType="warning" nzTheme="outline" class="viz-placeholder-icon"></span>
    <span class="viz-placeholder-text">Failed to fetch model slice</span>
    <pre class="viz-raw">{{ sliceResource.error() | json }}</pre>
  </div>
  }
  @else{
  <div class="viz-card">
    <div class="viz-head">
      <span class="viz-title" [title]="job()?.job_name"><b>{{ job().job_name}}</b></span>
      <span class="viz-badge" style="text-transform: uppercase; color: white">
        <b class="viz-badge-label">Model Type</b>
        <nz-select class="viz-select" [(ngModel)]="modelType" nzSize="small" nzVariant="borderless"
          style="color: white; text-align: right;" nzPlacement="bottomRight" nzShowSearch [nzDropdownMatchSelectWidth]="false">
          @if(modelTypesAvailable.isLoading() || modelTypesAvailable.error()){
          <nz-option [nzLabel]="modelType()" [nzValue]="modelType()"></nz-option>
          }@else() {
          @for (mType of modelTypesAvailable.value(); track $index){
          <nz-option [nzLabel]="mType.name" [nzValue]="mType.id" />
          }
          }
        </nz-select>
      </span>
    </div>

    <div class="viz-canvas">
      @if (sliceResource.isLoading()) {
      <div class="viz-placeholder">
        <span nz-icon nzType="loading" nzTheme="outline" class="viz-placeholder-icon"></span>
        <span class="viz-placeholder-text">Fetching model slice…</span>
      </div>
      } @else if (sliceResource.value(); as result) {
      <app-xwai-slice-viewer [sliceImage]="result.sliceImage" [sliceArray]="result.sliceArray"
        [colorbar]="result.colorbar" [limits]="result.limits" [dx]="dx()" [xLabel]="result.xLabel"
        [yLabel]="result.yLabel" [flippedYAxis]="result.flippedYAxis" [legendLabel]="modelType()"
        [shotsOverlayResource]="shotsOverlayResource" [shotsLocResource]="shotLocsResource"
        [shotColorMin]="shotColorMin()" [shotColorMax]="shotColorMax()" [xCrop]="xCropM()"
        [yCrop]="yCropM()" [cropMode]="cropMode()" (cropSelected)="onCropSelected($event)"
        [transposeDomains]="result.transposeDomains" />
      } @else {
      <div class="viz-placeholder">
        <span nz-icon nzType="picture" nzTheme="outline" class="viz-placeholder-icon"></span>
        <span class="viz-placeholder-text">Model preview not yet loaded</span>
      </div>
      }
      <button nz-button (click)="add_image_to_flipper()" class="add-image-to-flipper-button"
        nzSize="small" nz-tooltip nzTooltipTitle="Add to image flipper">
        <span nz-icon nzType="select" nzTheme="outline"></span>
      </button>
    </div>

    <!-- Only visible in mobile view, using css display: none-->
    <button class="viz-button flipper-button" nz-button nzType="primary" nzSize="small" (click)="add_image_to_flipper()">
      Add to Image Flipper
    </button>

    <!-- Immediate controls: re-fetch on change. -->
    <div class="viz-meta">
      <div class="viz-pill"><b>Colormap</b>
        @if(availableColormaps.hasValue()){
        <nz-select [(ngModel)]="cmap" style="text-align: right;" nzSize="small" nzVariant="borderless">
          @for (availableCmap of availableColormaps.value(); track $index) {
          <nz-option [nzValue]="availableCmap" [nzLabel]="availableCmap" />
          }
        </nz-select>
        }
      </div>
      <div class="viz-pill" style="flex-grow: 1; min-width: 160px;">
        <b>Iterations</b>
        <div style="flex-grow: 1;">
          <nz-slider [ngModel]="iteration()" (nzOnAfterChange)="onIterationRelease($event)"
            [nzMax]="viz().job.iterations_completed" [nzMin]="0"></nz-slider>
        </div>
      </div>
      @if(isDepthSlice()){
      <div class="viz-pill">
        <b>Show Shot Overlay</b>&nbsp;&nbsp;<nz-switch [(ngModel)]="showShotOverlay" />
      </div>
      @if(showShotOverlay()){
      <div class="viz-pill"><b>Shot Min</b>
        <nz-input-number [(ngModel)]="shotColorMin" nzSize="small"
          nzVariant="borderless" style="width: 70px;" />
      </div>
      <div class="viz-pill"><b>Shot Max</b>
        <nz-input-number [(ngModel)]="shotColorMax" nzSize="small"
          nzVariant="borderless" style="width: 70px;" />
      </div>
      }
      }
    </div>

    <!-- Deferred controls: edit freely, then Apply to re-fetch once. -->
    <div class="viz-deferred">
      @if (isZeroCentred()) {
      <div class="viz-pill"><b>± Range</b>
        <nz-input-number [(ngModel)]="draftRange" nzSize="small"
          nzVariant="borderless" [nzPlaceHolder]="(effectiveLimits()?.max | number: '1.0-2') ?? 'Global'"
          (keydown.enter)="applyChanges()" style="width: 100%;" />
      </div>
      } @else {
      <div class="viz-pill"><b>Min</b>
        <nz-input-number [(ngModel)]="draftMin" nzSize="small"
          nzVariant="borderless" [nzPlaceHolder]="(effectiveLimits()?.min | number: '1.0-2') ?? 'Global'"
          (keydown.enter)="applyChanges()" style="width: 100%;" />
      </div>
      <div class="viz-pill"><b>Max</b>
        <nz-input-number [(ngModel)]="draftMax" nzSize="small"
          nzVariant="borderless" [nzPlaceHolder]="(effectiveLimits()?.max | number: '1.0-2') ?? 'Global'"
          (keydown.enter)="applyChanges()" style="width: 100%;" />
      </div>
      }
      @if (isVpRefModel()) {
      <div class="viz-pill"><b>Vp ref</b>
        <nz-input-number [(ngModel)]="draftVpRef" nzSize="small"
          nzVariant="borderless" nzPlaceHolder="auto" (keydown.enter)="applyChanges()" style="width: 90px;" />
      </div>
      }

      <!-- Crop: client-side only, so applying it never re-fetches the slice. -->
      @if (extentMeters(); as extent) {
      <button class="viz-button crop-button" nz-button nzSize="small" nz-popover nzPopoverTrigger="click"
        [nzPopoverContent]="cropPopover" nzPopoverPlacement="topRight"
        [nzType]="hasCrop() ? 'primary' : 'default'">
        <span nz-icon nzType="scissor" nzTheme="outline"></span>
        Crop
      </button>
      <button class="viz-button crop-brush-button" nz-button nzSize="small" [nzType]="cropMode() ? 'primary' : 'default'"
        (click)="cropMode.set(!cropMode())" nz-tooltip
        nzTooltipTitle="Drag a box on the image to crop it">
        <span nz-icon nzType="borderless-table" nzTheme="outline"></span>
      </button>

      <ng-template #cropPopover>
        <div class="crop-popover">
          <div class="crop-popover-title">Crop (m)</div>
          <div class="crop-popover-row">
            <span class="crop-popover-label">{{ axisLabels().x }}</span>
            <nz-input-number [(ngModel)]="draftCropXMin" nzSize="small" [nzMin]="0" [nzMax]="extent.x"
              [nzStep]="100" nzPlaceHolder="0" (keydown.enter)="applyChanges()" />
            <nz-input-number [(ngModel)]="draftCropXMax" nzSize="small" [nzMin]="0" [nzMax]="extent.x"
              [nzStep]="100" [nzPlaceHolder]="extent.x | number: '1.0-0'" (keydown.enter)="applyChanges()" />
          </div>
          <div class="crop-popover-row">
            <span class="crop-popover-label">{{ axisLabels().y }}</span>
            <nz-input-number [(ngModel)]="draftCropYMin" nzSize="small" [nzMin]="0" [nzMax]="extent.y"
              [nzStep]="100" nzPlaceHolder="0" (keydown.enter)="applyChanges()" />
            <nz-input-number [(ngModel)]="draftCropYMax" nzSize="small" [nzMin]="0" [nzMax]="extent.y"
              [nzStep]="100" [nzPlaceHolder]="extent.y | number: '1.0-0'" (keydown.enter)="applyChanges()" />
          </div>
          <div class="crop-popover-actions">
            <button nz-button nzSize="small" nzType="link" (click)="resetCropDraft()">Reset crop</button>
            <button nz-button nzSize="small" nzType="primary" [disabled]="!pendingChanges()"
              (click)="applyChanges()">Apply</button>
          </div>
        </div>
      </ng-template>
      }

      <button class="viz-button" nz-button nzType="primary" nzSize="small" [disabled]="!pendingChanges()" (click)="applyChanges()">
        Apply
      </button>
    </div>
  </div>
  }
</div>